import { Navigate, Outlet } from 'react-router'
import { routes } from 'types/routes'
import { useTranslation } from 'react-i18next'
import PageLayout from 'layouts/page-layout/PageLayout.tsx'
import { PageTab } from 'layouts/page-layout/types.ts'
import styles from './Tariffs.module.scss'
import { useStoreSelector } from 'hooks/store.ts'
import { UserTypes } from 'store/auth/types.ts'
import { Heading, Tag } from '@boltenergy-be/design-system'

const Tariffs = () => {
  // Redux
  const { userType } = useStoreSelector((store) => store.auth)

  // i18n
  const { t } = useTranslation('tariffs')

  // Tabs
  const tabs: PageTab[] = [
    { label: t(($) => $.tabs.overview), path: routes.TARIFFS_OVERVIEW },
    { label: t(($) => $.tabs.products), path: routes.TARIFFS_PRODUCTS },
    { label: t(($) => $.tabs.discounts), path: routes.TARIFFS_DISCOUNTS }
  ]

  return userType !== UserTypes.SUPER_USER ? (
    <Navigate to={routes.OVERVIEW} replace />
  ) : (
    <PageLayout
      seoTitle={t(($) => $.title)}
      title={
        <span className="flex-row gap-500">
          <Heading as="h1" variant="h3" serif>
            {t(($) => $.title)}
          </Heading>

          <Tag type="soft">SUPERUSER ONLY</Tag>
        </span>
      }
      {...{ tabs }}
      classes={{ body: styles.body }}
    >
      <Outlet />
    </PageLayout>
  )
}

export default Tariffs
